import { Injectable } from '@angular/core';

import { AppState } from '../app-state';

import { RestClient } from './rest-client';
import { HttpClient } from '@angular/common/http';
import { Path } from '../models';



// basic service to read postgres 'path' table (needs connection and does not work in offline mode)

@Injectable({ providedIn: 'root' })
export class PathService extends RestClient<Path> {

    constructor(http: HttpClient, appState: AppState) {
        super(http, 'path', appState)
    }

}



